import { Chapter } from "@/components/Chapter";
import { Reveal } from "@/components/Reveal";

const PARTNERS = [
  { name: "Genetec", status: "integration in development", testid: "partner-genetec" },
  { name: "Axis", status: "Axis TIPP member", testid: "partner-axis" },
  { name: "Procore", status: "coming soon", testid: "partner-procore" },
];

export default function Partners() {
  return (
    <section id="partners" className="bg-white py-[88px]">
      <div className="mx-auto max-w-[1160px] px-6">
        <Chapter eyebrow="Works with" title="Built around the cameras and tools you already use." />
        <div className="grid sm:grid-cols-3 gap-5">
          {PARTNERS.map((p, i) => (
            <Reveal key={p.name} delay={i * 0.1} className="h-full">
              <div
                data-testid={p.testid}
                className="h-full bg-white border border-line rounded-[14px] p-8 text-center shadow-[0_2px_10px_rgba(23,71,95,0.05)]"
              >
                <p className="text-2xl font-extrabold text-navy">{p.name}</p>
                <p className="mt-3 text-xs font-bold uppercase tracking-[0.2em] text-steel">{p.status}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
